import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import Loader from "@componentsShared/Loader/Loader";
import UserEditNameComponent from "@/pages/user/UserAccountComponent/components/MyInfoComponent/UserEditNameComponent/UserEditNameComponent";
import useFullLoading from "@hooks/useFullLoading";
var UserEditName = function UserEditName() {
  var loading = useFullLoading();
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    mobileHasBack: true,
    hideFooter: true
  }, /*#__PURE__*/React.createElement(UserEditNameComponent, null));
};
export default UserEditName;